
export const OpcionesDeFiltro = [
    {
        key: 'Todes',
        text: 'Todes',
        value: 'Todes',
    /* label: { color: '', empty: true, circular: true }, */
    },
    {
        key: 'Egresade',
        text: 'Egresade',
        value: 'Egresade',
/*           label: { color: '', empty: true, circular: true },
*/ 
    },
    {
        key: 'Empleade',
        text: 'Empleade',
        value: 'Empleade',
        /* label: { color: '', empty: true, circular: true }, */
    }
];
